import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../../context/WalletContext';
import { useContract } from '../../context/ContractContext';
import Button from '../../components/common/Button/Button';
import logo from '../../assets/logo-full.png';
import './Landing.css';

const Landing = () => {
  const navigate = useNavigate();
  const { connect, isConnecting, isConnected, isInitializing } = useWallet();
  const { isRegistered, isCheckingRegistration, isAdmin } = useContract();

  const handleConnect = async () => {
    const success = await connect();
    if (success) {
      // Will redirect based on registration status via useEffect
    }
  };

  React.useEffect(() => {
    // Only redirect after wallet initialization AND registration check is complete
    if (isInitializing || isCheckingRegistration) return;
    
    if (isConnected) {
      if (isRegistered) {
        navigate('/dashboard');
      } else if (isAdmin) {
        // Admin wallet without a user account goes straight to the panel
        navigate('/admin');
      } else {
        navigate('/register');
      }
    }
  }, [isConnected, isRegistered, isAdmin, isInitializing, isCheckingRegistration, navigate]);

  const features = [
    { icon: '🤖', title: 'AI Trading', desc: 'Advanced AI algorithms for optimal returns' },
    { icon: '📈', title: 'Daily ROI', desc: 'Earn 1-3% daily returns on investment' },
    { icon: '⚡', title: 'Binary Income', desc: 'Powerful binary matching system' },
    { icon: '👥', title: 'Referral Rewards', desc: 'Earn from your direct referrals' }
  ];

  return (
    <div className="landing">
      <div className="landing-bg">
        <div className="landing-bg-orb orb-1" />
        <div className="landing-bg-orb orb-2" />
        <div className="landing-bg-grid" />
      </div>

      <div className="landing-content">
        <div className="landing-hero">
          <div className="landing-badge">
            <span>🇦🇪</span>
            <span>Dubai Based</span>
          </div>

          <div className="landing-logo">
            <img src={logo} alt="Gainforce" className="landing-logo-img" />
          </div>
          
          <p className="landing-tagline">
            AI-Powered Trading Platform
          </p>

          <p className="landing-subtitle">
            Next generation investment platform powered by artificial intelligence and blockchain technology
          </p>

          <div className="landing-stats">
            <div className="landing-stat">
              <span className="stat-value">300%</span>
              <span className="stat-label">Max Returns</span>
            </div>
            <div className="stat-divider"></div>
            <div className="landing-stat">
              <span className="stat-value">3%</span>
              <span className="stat-label">Daily ROI</span>
            </div>
            <div className="stat-divider"></div>
            <div className="landing-stat">
              <span className="stat-value">8</span>
              <span className="stat-label">Packages</span>
            </div>
          </div>

          <Button
            size="lg"
            fullWidth
            onClick={handleConnect}
            loading={isConnecting || (isConnected && isCheckingRegistration)}
          >
            {isConnecting ? 'Connecting...' : (isConnected && isCheckingRegistration) ? 'Checking...' : 'Connect Wallet'}
          </Button>

          <p className="landing-hint">
            Supports MetaMask, Trust Wallet & more
          </p>
        </div>

        <div className="landing-features">
          {features.map((feature, idx) => (
            <div key={idx} className="feature-card" style={{ animationDelay: `${idx * 0.1}s` }}>
              <span className="feature-icon">{feature.icon}</span>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="landing-packages">
          <h2 className="section-title">Investment Packages</h2>
          <div className="packages-list">
            {['10', '50', '100', '200', '300', '400', '500', '1000'].map((pkg, idx) => (
              <div key={idx} className="package-chip" style={{ animationDelay: `${idx * 0.05}s` }}>
                {pkg} USDT
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="landing-footer">
        <p>Powered by BNB Smart Chain</p>
      </div>
    </div>
  );
};

export default Landing;